import React from "react";

import * as yup from "yup";
import { Formik } from "formik";
import { useSlateStatic } from "slate-react";
import { Button, Form, Modal } from "react-bootstrap";

import RequiredAsterisk from "components/ui/RequiredAsterisk";

import { insertImage, isImageUrl } from "../../utils/imageUtils";

const InsertImageButton = () => {
  const editor = useSlateStatic();
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const validationSchema = yup.object({
    url: yup
      .string()
      .min(2, "URL is too Short!")
      .max(255, "URL is too Long!")
      .required("URL is required")
      .test("is-url-valid", "Not a valid image URL", (value) =>
        isImageUrl(value),
      ),
  });

  return (
    <>
      <Button
        size="sm"
        variant="white"
        onClick={handleShow}
        className={`border-0 bg-light`}
      >
        <span translate="no" className={`material-symbols-outlined md-16`}>
          image
        </span>
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Insert Image</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const { url } = values;
            insertImage(editor, url);
            handleClose();
          }}
          initialValues={{
            url: "",
            title: "",
            description: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group controlId="url" className="mb-3">
                  <Form.Label>
                    Source URL <RequiredAsterisk />
                  </Form.Label>
                  <Form.Control
                    placeholder="https://example.com/image.png"
                    type="url"
                    name="url"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.url}
                    isValid={values.url && !errors.url}
                    isInvalid={!!errors.url && touched.url}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.url && touched.url ? (
                      <small>{errors.url}</small>
                    ) : null}
                  </Form.Control.Feedback>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={handleClose}>
                  Close
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  type="submit"
                  disabled={!isValid}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default InsertImageButton;
